import React from "react";
import MainInput from "../Elements/MainInput/MainInput";
import Checkbox from "../Elements/Checkbox/Checkbox";
import LinkButton from "../Elements/LinkButton/LinkButton";
import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import ErrorMessage from "../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../Elements/SuccessMessage/SuccessMessage";
import "./AuthFormsCommon.css";
import GoogleAuthButton from "./GoogleAuthButton";
import AppleAuthButton from "./AppleAuthButton";
import FacebookAuthButton from "./FacebookAuthButton";

const AuthLoginForm = ({
  envelopeIcon,
  lockIcon,
  eye,
  eyeOff,
  email,
  password,
  rememberMe,
  showPassword,
  error,
  setError,
  isMobile,
  onEmailChange,
  onPasswordChange,
  onRememberChange,
  onTogglePassword,
  onForgotPassword,
  onLogin,
  onSwitchToRegister,
  successMessage,
  setSuccessMessage,
  onCloseError,
  onFacebookError,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="input-with-icon">
          <img src={envelopeIcon} className="input-icon" alt="email icon" />
          <MainInput
            placeholder="Email"
            type="email"
            autoComplete="new-email"
            value={email}
            onChange={(e) => {
              onEmailChange(e.target.value);
              if (error) onCloseError();
            }}
          />
        </div>
        <div className="input-with-icon">
          <img src={lockIcon} className="input-icon" alt="lock icon" />
          <MainInput
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={password}
            onChange={(e) => {
              onPasswordChange(e.target.value);
              if (error) onCloseError();
            }}
          />
          {password.length > 0 && (
            <img
              src={showPassword ? eyeOff : eye}
              className="input-icon"
              alt={showPassword ? "hide password" : "show password"}
              onClick={onTogglePassword}
              style={{ right: "1.3rem", left: "auto", cursor: "pointer" }}
            />
          )}
        </div>
        <div className="form-options">
          <Checkbox
            label="Remember me"
            id="remember"
            checked={rememberMe}
            onChange={(e) => onRememberChange(e.target.checked)}
          />
          <LinkButton onClick={onForgotPassword}>Forgot the password?</LinkButton>
        </div>
        <div className="auth-btn-group">
          <MainButton className="sign-in-btn" type="submit">
            Sign In
          </MainButton>
          {isMobile && (
            <SecondButton className="register-btn" onClick={onSwitchToRegister}>
              Register
            </SecondButton>
          )}
        </div>
        <div className="social-login-section">
          <div className="social-divider">or continue with</div>
          <div className="social-login-cont">
            <GoogleAuthButton
              onError={(err) => setError(err.message)}
              onSuccess={() => setSuccessMessage("Google Logged In")}
            />
            <FacebookAuthButton
              onError={(message) => setError(message)}
              onSuccess={() => setSuccessMessage("Signed in with Facebook successfully.")}
            />
            <AppleAuthButton
              onError={(err) => setError(err.message)}
              onSuccess={() => setSuccessMessage("Apple Logged In")}
            />
          </div>
        </div>
        {error && <ErrorMessage message={error} onClose={onCloseError} />}
        {successMessage && <SuccessMessage message={successMessage} onClose={() => setSuccessMessage(null)} />}
      </form>
    </>
  );
};

export default AuthLoginForm;
